import React from 'react';
import { Grid, Button, Typography, Divider, Box, Paper } from '@mui/material';
import SignatureCanvas from 'react-signature-canvas';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';

const SignaturesSection = ({ 
  formData, 
  signatureDialogOpen, 
  signaturePadRef, 
  handleSignatureOpen, 
  handleSignatureClear, 
  handleSignatureSave, 
  handleSignatureClose 
}) => {
  return (
    <Box>
      <Typography variant="h6" sx={{ color: '#008080', mb: 2, fontWeight: 600 }}>Verification & Signatures</Typography>
      <Divider sx={{ mb: 3 }} />
      
      <Grid container spacing={4}>
        <Grid item xs={12} sm={6}>
          <Box sx={{ mb: 2 }}>
            <Typography variant="subtitle2" gutterBottom>Relative's Signature</Typography>
            {formData.relatives_signature ? (
              <Paper variant="outlined" sx={{ p: 1, backgroundColor: '#f9f9f9', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <img 
                  src={`data:image/png;base64,${formData.relatives_signature}`} 
                  alt="Relative Signature" 
                  style={{ maxHeight: '100px', maxWidth: '100%' }} 
                />
                <Button size="small" onClick={() => handleSignatureOpen('relatives_signature')} sx={{ mt: 1 }}>
                  Resign
                </Button>
              </Paper>
            ) : (
              <Button 
                variant="outlined" 
                fullWidth 
                onClick={() => handleSignatureOpen('relatives_signature')}
                sx={{ py: 3, borderStyle: 'dashed' }}
              >
                Sign Relative
              </Button>
            )}
          </Box>
        </Grid>

        <Grid item xs={12} sm={6}>
          <Box sx={{ mb: 2 }}>
            <Typography variant="subtitle2" gutterBottom>Handover Signature</Typography>
            {formData.handover_signature ? (
              <Paper variant="outlined" sx={{ p: 1, backgroundColor: '#f9f9f9', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <img 
                  src={`data:image/png;base64,${formData.handover_signature}`} 
                  alt="Handover Signature" 
                  style={{ maxHeight: '100px', maxWidth: '100%' }} 
                />
                <Button size="small" onClick={() => handleSignatureOpen('handover_signature')} sx={{ mt: 1 }}>
                  Resign
                </Button>
              </Paper>
            ) : (
              <Button 
                variant="outlined" 
                fullWidth 
                onClick={() => handleSignatureOpen('handover_signature')}
                sx={{ py: 3, borderStyle: 'dashed' }}
              >
                Sign Handover
              </Button>
            )}
          </Box>
        </Grid>
      </Grid>

      {/* Signature Dialog */}
      <Dialog open={signatureDialogOpen} onClose={handleSignatureClose} maxWidth="sm" fullWidth>
        <DialogTitle>Provide Your Signature</DialogTitle>
        <DialogContent>
          <Box sx={{ border: '1px solid #ccc', borderRadius: '4px', mt: 1 }}>
            <SignatureCanvas
              ref={signaturePadRef}
              penColor="black"
              canvasProps={{ width: 550, height: 200, className: 'sigCanvas' }}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSignatureClear} color="secondary">Clear</Button>
          <Button onClick={handleSignatureClose}>Close</Button>
          <Button onClick={handleSignatureSave} variant="contained" color="primary">Done</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default SignaturesSection;
